module.exports = __webpack_public_path__ + "static/img/topleft_1.4432667.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topleft_1.png
// module id = 7sU5
// module chunks = 1